import actions from './actions'
import getters from './getters'
import * as types from './types'

const state = {
  etps: [],
  selectedEtp: null,
  filters: {
    clientName: '',
    clientCountry: '',
    createdAtFrom: null,
    createdAtTo: null,
    amountFrom: 0,
    amountTo: 0,
    isin: '',
    states: []
  },
  pagination: {
    sortDesc: [true],
    page: 1,
    itemsPerPage: 20,
    sortBy: ['created_at']
  },
  totalItems: 0,
  isLoading: false,
  isDialogLoading: false,
  dialogsVisibility: {
    biddingDialog: false
  },
  investors: [],
  manualBid: {
    selectedInvestor: null,
    accounts: [],
    selectedAccount: null,
    bid_data: {
      balance: null,
      etp_amount: null,
      pending_amount: null,
      bid_size: null
    }
  }
}

const mutations = {
  [types.SET_ETPS](state, value) {
    state.etps = value
  },
  [types.SET_SELECTED_ETP](state, value) {
    state.selectedEtp = value
  },
  [types.SET_PAGINATION](state, value) {
    state.pagination = value
  },
  [types.SET_TOTAL_ITEMS](state, value) {
    state.totalItems = value
  },
  [types.SET_IS_LOADING](state, value) {
    state.isLoading = value
  },
  [types.SET_FILTERS](state, { key, value }) {
    state.filters = {
      ...state.filters,
      [key]: value
    }
  },
  [types.SET_BIDDING_DIALOG](state, value) {
    state.dialogsVisibility = {
      ...state.dialogsVisibility,
      biddingDialog: value
    }
  },
  [types.SET_INVESTORS](state, value) {
    state.investors = value
  },
  [types.SET_SELECTED_INVESTOR](state, value) {
    state.manualBid = {
      ...state.manualBid,
      selectedInvestor: value
    }
  },
  [types.SET_ACCOUNTS](state, value) {
    state.manualBid = {
      ...state.manualBid,
      accounts: value
    }
  },
  [types.SET_SELECTED_ACCOUNT](state, value) {
    state.manualBid = {
      ...state.manualBid,
      selectedAccount: value
    }
  },
  [types.SET_ACCOUNT_BALANCE](state, value) {
    state.manualBid = {
      ...state.manualBid,
      bid_data: {
        ...state.manualBid.bid_data,
        balance: value
      }
    }
  },
  [types.SET_ETP_PENDING_AMOUNT](state, value) {
    state.manualBid = {
      ...state.manualBid,
      bid_data: {
        ...state.manualBid.bid_data,
        pending_amount: value
      }
    }
  },
  [types.SET_BID_SIZE](state, value) {
    state.manualBid = {
      ...state.manualBid,
      bid_data: {
        ...state.manualBid.bid_data,
        bid_size: value
      }
    }
  },
  [types.SET_CLEAR_BID_DATA](state) {
    state.manualBid = {
      selectedInvestor: null,
      accounts: [],
      selectedAccount: null,
      bid_data: {
        balance: null,
        etrc_amount: null,
        pending_amount: null,
        bid_size: null
      }
    }
  },
  [types.SET_IS_DIALOG_LOADING](state, value) {
    state.isDialogLoading = value
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
